import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpLoadingService } from '../../services/http-loading.service';

@Component({
  selector: 'app-http-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './http-spinner.component.html',
  styleUrl: './http-spinner.component.scss',
})
export class HttpSpinnerComponent {
  protected readonly isLoading = inject(HttpLoadingService).isLoading;
}
